function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonoIntow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2E90FA",
    style: {
      fill: "#2E90FA",
      fill: "color(display-p3 0.1804 0.5647 0.9804)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2E90FA",
    style: {
      fill: "#2E90FA",
      fill: "color(display-p3 0.1804 0.5647 0.9804)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#2E90FA",
    style: {
      fill: "#2E90FA",
      fill: "color(display-p3 0.1804 0.5647 0.9804)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonoIntow);
export default __webpack_public_path__ + "static/media/mono_intow.8f7e1a0a47192c013fc7d77ee467254c.svg";
export { ForwardRef as ReactComponent };